import InputNumberDouble from 'components/InputNumberDouble'
import Label from 'components/Label'

interface Props {
  label?: string
  tooltip?: JSX.Element
  leftInput: {
    value: number | string | null
    onChange: (newValue: number) => void
  }
  rightInput: {
    value: number | string | null
    onChange: (newValue: number) => void
  }
  className?: string
  disabled?: boolean
}

const defaultProps = {
  label: 'Surface habitable : ',
  tooltip: undefined,
  className: undefined,
  disabled: false,
}

const InputSurfaceHabitable = ({
  label = defaultProps.label,
  tooltip = defaultProps.tooltip,
  leftInput,
  rightInput,
  className,
  disabled,
}: Props): JSX.Element => (
  <div className={className}>
    <Label label={label} tooltip={tooltip} />
    <InputNumberDouble
      labelStart="De"
      labelMid="à"
      labelEnd="m²"
      leftInput={leftInput}
      rightInput={rightInput}
      disabled={disabled}
    />
  </div>
)
InputSurfaceHabitable.defaultProps = defaultProps
export default InputSurfaceHabitable
